import React from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAuthorizedPerson } from "../../../../models/response/company/GetCompanyByIdResponse";
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { ConstantService } from "../../../../services/ConstantService";
import { FastFirmFields } from "../../../../components/FastFirm";

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCurrentCompany: CustomSingleSelectModel | undefined
    setSelectedCurrentCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setCompanyAuthorizedPersons: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAuthorizedPerson[]>>
    authorizedPersonSelectHandler: (_selectedAuthorizedPerson: CustomSingleSelectModel | undefined, _list?: GetCompanyByIdResponseCompanyAuthorizedPerson[] | undefined, phoneToBeSet?: string | undefined, emailToBeSet?: string | undefined) => void
    setSelectedAuthorizedPerson: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setPhoneList: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setSelectedPhone: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setEmailList: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setSelectedEmail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedAuthorizedPerson: CustomSingleSelectModel | undefined
    companyAuthorizedPersons: GetCompanyByIdResponseCompanyAuthorizedPerson[]
    selectedPhone: CustomSingleSelectModel | undefined
    phoneList: CustomSingleSelectModel[]
    selectedEmail: CustomSingleSelectModel | undefined
    emailList: CustomSingleSelectModel[]
    selectedMeetingType: CustomSingleSelectModel | undefined
    setSelectedMeetingType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedMeetingRemindReason: CustomSingleSelectModel | undefined
    setSelectedMeetingRemindReason: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    note: string | undefined
    setNote: React.Dispatch<React.SetStateAction<string | undefined>>
    remindDate: string | undefined
    setRemindDate: React.Dispatch<React.SetStateAction<string | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    refNo,
    setRefNo,
    selectedCurrentCompany,
    setSelectedCurrentCompany,
    setCompanyAuthorizedPersons,
    authorizedPersonSelectHandler,
    setSelectedAuthorizedPerson,
    setPhoneList,
    setSelectedPhone,
    setEmailList,
    setSelectedEmail,
    selectedAuthorizedPerson,
    companyAuthorizedPersons,
    selectedPhone,
    phoneList,
    selectedEmail,
    emailList,
    selectedMeetingType,
    setSelectedMeetingType,
    selectedMeetingRemindReason,
    setSelectedMeetingRemindReason,
    note,
    setNote,
    remindDate,
    setRemindDate
}: Props) => {
    const dispatch = useDispatch();

    const companySelectedHandler = async (_companyId: string | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            if (_companyId && !Helpers.isEmpty(_companyId)) {
                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCompanyAuthorizedPersons(response.data.companyAuthorizedPersons);

                if (response.data.companyAuthorizedPersons.length == 1) {
                    var firstOne = response.data.companyAuthorizedPersons[0];
                    authorizedPersonSelectHandler({ label: firstOne.name + ' ' + firstOne.surname, value: firstOne.companyAuthorizedPersonId }, response.data.companyAuthorizedPersons);
                    return;
                }
            }
            else {
                setCompanyAuthorizedPersons([]);
            }

            setSelectedAuthorizedPerson(undefined);
            setPhoneList([]);
            setSelectedPhone(undefined);
            setEmailList([]);
            setSelectedEmail(undefined);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <Box gap="20px" flexDirection="row">
                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={refNo} onChange={(e) => setRefNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Firma Adı</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCurrentCompany}
                                    onChange={(selectedValue) => {
                                        setSelectedCurrentCompany(selectedValue);
                                        companySelectedHandler(selectedValue?.value);
                                    }}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedCurrentCompany?.value,
                                                isCustomer: true,
                                                isAgency: true,
                                                isSupplier: true,
                                                allowedFields: [FastFirmFields.FirmName, FastFirmFields.AuthorizedPerson],
                                                onSubmit: async (response) => {
                                                    setSelectedCurrentCompany({ label: response.name, value: response.companyId })
                                                    companySelectedHandler(response.companyId);
                                                },
                                                defaultInitialCompanyTypeId: '1'
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili Kişi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedAuthorizedPerson}
                                    onChange={authorizedPersonSelectHandler}
                                    onMenuOpen={async () => {
                                        return {
                                            isSuccess: true,
                                            data: companyAuthorizedPersons.map(function (x) {
                                                return { label: x.name + ' ' + x.surname, value: x.companyAuthorizedPersonId }
                                            })
                                        }
                                    }}
                                    labelName='label'
                                    valueName='value'
                                />
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Görüşme Şekli</label>
                                <CustomSingleSelect
                                    selectedValue={selectedMeetingType}
                                    onChange={setSelectedMeetingType}
                                    onMenuOpen={() => ConstantService.getConstantList('MEETING_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili Telefon</label>

                                <CustomSingleSelect
                                    selectedValue={selectedPhone}
                                    onChange={setSelectedPhone}
                                    onMenuOpen={async () => {
                                        return {
                                            isSuccess: true,
                                            data: phoneList
                                        }
                                    }}
                                    labelName='label'
                                    valueName='value'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili E-Posta</label>

                                <CustomSingleSelect
                                    selectedValue={selectedEmail}
                                    onChange={setSelectedEmail}
                                    onMenuOpen={async () => {
                                        return {
                                            isSuccess: true,
                                            data: emailList
                                        }
                                    }}
                                    labelName='label'
                                    valueName='value'
                                />
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Hatırlatma Nedeni</label>
                                <CustomSingleSelect
                                    selectedValue={selectedMeetingRemindReason}
                                    onChange={setSelectedMeetingRemindReason}
                                    onMenuOpen={() => ConstantService.getConstantList('MEETING_REMIND_REASON')}
                                    insertable={{
                                        onSubmit: { code: 'MEETING_REMIND_REASON' }
                                    }}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Hatırlatma Zamanı</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={remindDate} onChange={(e) => setRemindDate(e.target.value)} type="datetime-local" className="form-control form-control-solid" />
                            </div>
                        </Box>
                    </Box>

                    <Box className="mt-5">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Görüşme Notu</label>
                        <textarea value={note} onChange={(e) => setNote(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 100, resize: 'none' }} className="form-control form-control-solid" />
                    </Box>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;